import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { globalPropTypes } from 'helpers';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createMaCisCreator,
  loadAllowedCbLevelDomainsCreator,
  loadClientMemberAssociationsByCBCreator,
  loadGlobalCisCertificatesAttributesCreator,
  setMaCisCreateErrorsCreator,
  setMaCisCreatedCreator,
} from '../../../../../store/actionsCreators';
import AddCertificate from '../../../../../shared/Cis/Certificates/Add/AddCertificate';
import { useEffect } from 'react';

const AddMaCertificate = ({
  errors,
  createCertificate,
  removeError,
  certificationBodies,
  levelDomains,
  loadCertificatesAttributes,
  organizations,
  loadClientMemberAssociations,
  memberAssociations,
  userCb,
  createdHolder,
  resetCreatedHolder,
  languages,
  loadAllowedLevelDomains,
  allowedLevelDomains,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  const userCbId = userCb?.id;

  useEffect(() => {
    if (Number.isInteger(userCbId)) {
      loadAllowedLevelDomains(userCbId);
    }
  }, [loadAllowedLevelDomains, userCbId]);

  useEffect(() => {
    if (!state.certificationBody && Number.isInteger(userCbId)) {
      dispatch(updateFieldCreator({ name: 'certificationBody', value: userCbId }));
    }
  }, [state.certificationBody, userCbId, dispatch]);

  const usableLevelDomains = allowedLevelDomains.length
    ? levelDomains.filter((ld) => allowedLevelDomains.includes(ld.value))
    : levelDomains;

  return (
    <AddCertificate
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createCertificate={createCertificate}
      removeError={removeError}
      certificationBodies={certificationBodies}
      loadCertificatesAttributes={loadCertificatesAttributes}
      levelDomains={usableLevelDomains}
      organizations={organizations}
      loadClientMemberAssociations={loadClientMemberAssociations}
      memberAssociations={memberAssociations}
      createdHolder={createdHolder}
      resetCreatedHolder={resetCreatedHolder}
      type="ma"
      languages={languages}
      signaturesRequired={!userCb?.signaturesNotRequired}
    />
  );
};

AddMaCertificate.propTypes = {
  errors: PropTypes.shape({
    certificateHolder: PropTypes.string,
    certificateLevelDomain: PropTypes.string,
    certificationBody: PropTypes.string,
    issueDate: PropTypes.string,
    type: PropTypes.string,
    validUntil: PropTypes.string,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.string,
    visibility: PropTypes.string,
    organization: PropTypes.string,
    memberAssociation: PropTypes.string,
  }),
  createCertificate: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  levelDomains: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  createdHolder: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  resetCreatedHolder: PropTypes.func.isRequired,
};

AddMaCertificate.defaultProps = {
  createdHolder: {},
  errors: {},
};

const mapStateToProps = ({ ma, globals, user }) => ({
  errors: ma.cis.certificates.createErrors,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  organizations: globals.cis.organizations,
  memberAssociations: globals.cis.clientMemberAssociations,
  userCb: user.user.memberAssociation?.certificationBody,
  createdHolder: ma.cis.certificateHolders.created,
  languages: globals.languages,
  allowedLevelDomains: ma.cis.allowedCbLevelDomains,
});

const mapDispatchToProps = (dispatch) => ({
  createCertificate: (payload, history) =>
    dispatch(createMaCisCreator('certificates', payload, history)),
  removeError: (payload) => dispatch(setMaCisCreateErrorsCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
  loadClientMemberAssociations: (payload) =>
    dispatch(loadClientMemberAssociationsByCBCreator(payload)),
  resetCreatedHolder: () => dispatch(setMaCisCreatedCreator('certificateHolders', undefined)),
  loadAllowedLevelDomains: (payload) => dispatch(loadAllowedCbLevelDomainsCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMaCertificate);
